const RENDER_ARTIFACT_ATTR = 'data-render-artifact';

export function markRenderArtifact(element) {
    element.setAttribute(RENDER_ARTIFACT_ATTR, '');
    return element;
}

export function isRenderArtifact(node) {
    return node.nodeType === Node.ELEMENT_NODE && node.hasAttribute(RENDER_ARTIFACT_ATTR);
}
